import { render } from "./Cancel.vue?vue&type=template&id=40de71a3&scoped=true"
import script from "./Cancel.vue?vue&type=script&lang=js"
export * from "./Cancel.vue?vue&type=script&lang=js"

import "./Cancel.vue?vue&type=style&index=0&id=40de71a3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40de71a3"]])

export default __exports__